import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import RenderStatus from "../../styles/styledStatus";
import { TextField } from "@material-ui/core";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import ClipboardInput from "../../elements/copyToClipboard/ClipboardInput";
import * as moment from "moment";
import { AppContext } from "../../../App";

import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledContentWrapper } from "../../styles/styledMain";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { StyledPayoutDetailsWrapper } from "../../payouts/styledPayout";
import TransactionFailForm from "./TransactionFailForm";
import { useTranslation } from "react-i18next";

const PayoutDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();
  let [transaction, setTransaction] = useState();

  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchTransaction = () => {
    axios.get(`/api/${match.params.type}/${match.params.id}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setTransaction(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchTransaction();
  }, []);

  if (!transaction) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.transactionTitle")}</title>
        </Helmet>
        <StyledPayoutDetailsWrapper>
          <div className="refiling-details-head">
            <GoToBackButton
              pb="10"
              handler={() => {history.goBack();}}
            />
            <div className="refiling-details-head__status">
              <RenderStatus status={transaction.status.value} />
            </div>
          </div>
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("transactionDetails")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <ClipboardInput
                  label="Id"
                  value={transaction.id}
                  readonly={true}
                />
                <ClipboardInput
                  label="Reference id"
                  value={transaction.referenceId}
                  readonly={true}
                />
                <TextField
                  className="grid-form__input"
                  label={t("project")}
                  type="text"
                  value={transaction.connection.project.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("service")}
                  type="text"
                  value={getServiceNameWithNickname(transaction.connection.service.name, transaction.connection.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("paymentSystem")}
                  type="text"
                  value={transaction.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("currency")}
                  type="text"
                  value={transaction.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("amount")}
                  type="text"
                  value={transaction.amount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("processedAmount.payout")}
                  type="text"
                  value={transaction.processedAmount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("createdAt")}
                  type="text"
                  value={moment((transaction.createdAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("updatedAt")}
                  type="text"
                  value={moment((transaction.updatedAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("paymentType")}
                  type="text"
                  value={transaction.paymentType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("transactionType")}
                  type="text"
                  value={transaction.transactionType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                {transaction.relatedReferenceId &&
                  <TextField
                    className="grid-form__input"
                    label="Related reference id"
                    type="text"
                    value={transaction.relatedReferenceId}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
                {transaction.note &&
                  <TextField
                    className="grid-form__input"
                    label={t("note")}
                    type="text"
                    value={transaction.note}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>

            {!["PROCESSED", "FAIL"].includes(transaction.status.value) && (
              <TransactionFailForm
                transactionId={transaction.id}
                notification={notification}
                setNotification={setNotification}
                type={transaction.type}
                fetchAction={fetchTransaction}
              />
            )}
          </StyledFormGrid>
        </StyledPayoutDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PayoutDetailsContainer;